import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { FiMessageCircle, FiAlertTriangle, FiAlertCircle, FiInfo } from 'react-icons/fi';
import { getPriorityClass } from '../data/notificationsData';

const ThreadsList = () => {
  const { currentThreads, selectThread, markCurrentServiceAsRead } = useNotifications();

  // Show empty state if no threads
  if (currentThreads.length === 0) {
    return (
      <div className="empty-state">
        <FiMessageCircle className="empty-icon" />
        <h3 className="empty-title">No Threads</h3>
        <p className="empty-description">
          There are no notification threads available.
        </p>
      </div>
    );
  }

  // Format date to display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
  };

  // Format category label
  const formatCategory = (category) => {
    return category.charAt(0).toUpperCase() + category.slice(1);
  };

  // Get priority icon
  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'emergency':
        return <FiAlertTriangle className="priority-icon priority-icon-emergency" aria-label="Emergency" />;
      case 'important':
        return <FiAlertCircle className="priority-icon priority-icon-important" aria-label="Important" />;
      default:
        return <FiInfo className="priority-icon priority-icon-standard" aria-label="Information" />;
    }
  };

  // Get priority text
  const getPriorityText = (priority) => {
    switch (priority) {
      case 'emergency':
        return 'URGENT';
      case 'important':
        return 'IMPORTANT';
      default:
        return '';
    }
  };

  return (
    <div className="threads-list">
      {currentThreads.some(thread => thread.unreadCount > 0) && (
        <button
          className="mark-all-button"
          onClick={markCurrentServiceAsRead}
        >
          Mark all as read
        </button>
      )}

      {currentThreads.map((thread) => (
        <div
          key={thread.id}
          className={`thread-item ${getPriorityClass(thread.priority)}`}
          onClick={() => selectThread(thread.id)}
          role="article"
          aria-label={`${thread.priority === 'emergency' ? 'Emergency' : thread.priority === 'important' ? 'Important' : ''} ${thread.category} thread`}
        >
          <span className={`category-label-corner ${thread.category}`}>
            {formatCategory(thread.category)}
          </span>
          <div className="thread-content">
            <div className="thread-header">
              <div className="thread-title-row">
                {getPriorityIcon(thread.priority)}
                <h3 className="thread-title">
                  {getPriorityText(thread.priority) && (
                    <span className="priority-text">{getPriorityText(thread.priority)}: </span>
                  )}
                  {thread.title}
                </h3>
              </div>
              <span className="thread-time">
                {formatDate(thread.latestDate)} {thread.latestTime}
              </span>
            </div>
            <div className="thread-providers">
              {thread.serviceName}
            </div>
            <div className="thread-footer">
              <div className="thread-count">
                {thread.count} message{thread.count !== 1 ? 's' : ''}
                {thread.unreadCount > 0 && (
                  <span className="thread-badge">{thread.unreadCount}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ThreadsList;